import axiosInstance from "./apiinterseptor";
import { toast } from "react-hot-toast";

export type BlockedCandidateRecord = {
  _id: string;
  phone: string;
  reason?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  blockedBy?:
    | string
    | {
        _id: string;
        username?: string;
        email?: string;
      };
};

export const getBlockedCandidates = async (
  params: { page?: number; limit?: number; search?: string } = {}
) => {
  try {
    const query = new URLSearchParams();
    if (params.page) query.set("page", String(params.page));
    if (params.limit) query.set("limit", String(params.limit));
    if (params.search) query.set("search", params.search);

    const qs = query.toString();
    const response = await axiosInstance.get(
      `/blocked-candidates${qs ? `?${qs}` : ""}`
    );

    return {
      ...response.data,
      data: (response.data.data?.blockedCandidates ??
        []) as BlockedCandidateRecord[],
    };
  } catch (error: any) {
    toast.error(
      error.response?.data?.message || "Failed to load blocked candidates"
    );
    throw error;
  }
};

export const createBlockedCandidate = async (payload: {
  phone: string;
  reason?: string;
}) => {
  try {
    const response = await axiosInstance.post(`/blocked-candidates`, payload);
    toast.success(
      response.data?.message || "Mobile number blocked successfully"
    );
    return response.data;
  } catch (error: any) {
    toast.error(
      error.response?.data?.message || "Failed to block mobile number"
    );
    throw error;
  }
};

export const unblockBlockedCandidate = async (id: string) => {
  try {
    const response = await axiosInstance.patch(
      `/blocked-candidates/${id}/unblock`
    );
    toast.success(
      response.data?.message || "Mobile number unblocked successfully"
    );
    return response.data;
  } catch (error: any) {
    toast.error(
      error.response?.data?.message || "Failed to unblock mobile number"
    );
    throw error;
  }
};

/** Returns blocked status for a phone (used before Schedule → Add Candidate). */
export const checkPhoneBlocked = async (phone: string): Promise<{
  blocked: boolean;
  message?: string;
}> => {
  const digits = String(phone ?? "").replace(/\D/g, "");
  const normalized = digits.length >= 10 ? digits.slice(-10) : digits;
  if (!normalized || normalized.length < 10) {
    return { blocked: false };
  }

  const response = await axiosInstance.get(`/blocked-candidates/check`, {
    params: { phone: normalized },
  });
  return {
    blocked: Boolean(response.data?.data?.blocked),
    message: response.data?.data?.message,
  };
};
